import { render, staticRenderFns } from "./GeschaeftspartnerNewViva.vue?vue&type=template&id=9945a440"
import script from "./GeschaeftspartnerNewViva.vue?vue&type=script&lang=js"
export * from "./GeschaeftspartnerNewViva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports